import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEyeOff24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconEyeOff24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m6.792 18.153-.95.95a.75.75 0 1 1-1.06-1.061L18.16 4.664a.75.75 0 0 1 1.06 1.06l-.81.812c1.642 1.443 2.734 3.177 3.32 4.27a2.26 2.26 0 0 1 0 2.154c-1.157 2.158-4.28 6.806-9.729 6.806-2.063 0-3.793-.667-5.21-1.613M17.346 7.6c1.464 1.26 2.477 2.825 3.062 3.916.127.236.127.5 0 .736-1.135 2.117-3.88 6.015-8.407 6.015-1.592 0-2.964-.482-4.122-1.2l1.66-1.66a4.297 4.297 0 0 0 5.985-5.985zm-2.908 2.909-3.812 3.812a2.8 2.8 0 0 0 4.078-1.713 2.8 2.8 0 0 0-.267-2.1M3.595 12.25c.43.803 1.092 1.862 1.995 2.867L4.529 16.18a16.4 16.4 0 0 1-2.256-3.22 2.26 2.26 0 0 1 0-2.154C3.43 8.648 6.553 4 12 4c1.448 0 2.731.328 3.857.85L14.71 5.997A7.6 7.6 0 0 0 12 5.5c-4.527 0-7.271 3.898-8.406 6.015a.76.76 0 0 0 0 .736"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEyeOff24);
